export default __webpack_public_path__ + "static/media/logistics-management.fec6f164.jpg";